import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Box, IconButton, Tab, Tabs } from '@mui/material';
import { ArrowBack as BackIcon } from '@mui/icons-material';
import { ChainPerformance } from '../components/performance/ChainPerformance';
import { TargetTests } from '../components/tests/TargetTests';
import { PageBreadcrumbs } from '../components/PageBreadcrumbs';
import { useAuth } from '../contexts/AuthContext';
import { useTestsAccess } from '../services/testsApi';
import { isOtherCustomer } from '../utils/auth';

export const ChainPerformancePage: React.FC = () => {
  const { chainId } = useParams<{ chainId: string }>();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { permissions, getIdToken } = useAuth();
  const param = searchParams.get('customer_id');
  const customerId = isOtherCustomer(param, permissions) ? param : null;
  const listPath = customerId ? `/dashboard/function-runs?customer_id=${encodeURIComponent(customerId)}` : '/dashboard/function-runs';
  const { enabled: testsEnabled } = useTestsAccess(getIdToken, customerId);
  const tab = searchParams.get('tab') === 'tests' && testsEnabled ? 'tests' : 'performance';

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <IconButton onClick={() => navigate(-1)}>
          <BackIcon />
        </IconButton>
        <PageBreadcrumbs
          items={[
            { label: customerId ? `Runs & Performance · ${customerId}` : 'Runs & Performance', to: listPath },
            { label: tab === 'tests' ? 'Chain tests' : 'Chain performance' },
          ]}
        />
      </Box>
      {testsEnabled && (
        <Tabs
          value={tab}
          onChange={(_, v) => {
            const next = new URLSearchParams(searchParams);
            if (v === 'tests') next.set('tab', 'tests');
            else next.delete('tab');
            setSearchParams(next, { replace: true });
          }}
          sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab value="performance" label="Performance" />
          <Tab value="tests" label="Tests" />
        </Tabs>
      )}
      {chainId && tab === 'performance' && <ChainPerformance chainId={chainId} customerId={customerId} />}
      {chainId && tab === 'tests' && <TargetTests targetType="chain" targetId={chainId} customerId={customerId} />}
    </Box>
  );
};

export default ChainPerformancePage;
